import { getMaxAllowedPaymentInAdvance } from './getMaxAllowedPaymentInAdvance';

export const checkIfPaymentInAdvanceAmountIsValid = (
	paymentInAdvanceAmount: number | undefined,
	totalPricePerMonth: number,
	duration: number
): boolean => {
	if (paymentInAdvanceAmount === undefined) {
		return false;
	}
	const maxAllowedPayment = getMaxAllowedPaymentInAdvance(totalPricePerMonth * duration);
	return (
		paymentInAdvanceAmount >= 1000 &&
		paymentInAdvanceAmount <= maxAllowedPayment &&
		paymentInAdvanceAmount === Math.floor(paymentInAdvanceAmount)
	);
};
